import actions from './actions';

const initialState = {
  data: [],
  url: null,
  fileLoading: false, 
  loading: false,
  error: null,
};


const searchState = {
  data: [],
  loading: false,
  error: null,
};

const initialStateSingle = {
  data: null,
  loading: false,
  error: null,
};

const organizationsReducer = (state = initialState, action) => {
  const { type, data, err } = action;
  switch (type) {

    case actions.ORGANIZATION_ADD_BEGIN:
      return {
        ...state,
        loading: true,
      };

    case actions.ORGANIZATION_ADD_SUCCESS:
      return {
        ...state,
        data,
        error: false,
        loading: false,
      };

    case actions.ORGANIZATION_ADD_ERR:
      return {
        ...state,
        error: err,
        loading: false,
      };

    case actions.ORGANIZATIONS_READ_BEGIN:
      return {
        ...state,
        loading: true,
      };
    case actions.ORGANIZATIONS_READ_SUCCESS:
      return {
        ...state,
        data, 
        error: false,
        loading: false,
      };
    case actions.ORGANIZATIONS_READ_ERR:
      return {
        ...state,
        error: err,
        loading: false,
      };

    case actions.ORGANIZATION_UPDATE_BEGIN:
      return {
        ...state,
        loading: true,
      };
    case actions.ORGANIZATION_UPDATE_SUCCESS:
      return {
        ...state,
        data, 
        error: false,
        loading: false,
      };
    case actions.ORGANIZATION_UPDATE_ERR:
      return {
        ...state,
        error: err,
        loading: false,
      };
    default:
      return state;
  }
};


const organizationSearchReducer = (state = searchState, action) => {
  const { type, data, err } = action;
  switch (type) {
    case actions.SEARCH_ORGANIZATION_BEGIN:
      return {
        ...state,
        loading: true,
      };
    case actions.SEARCH_ORGANIZATION_SUCCESS:
      return {
        ...state,
        data, 
        error: false,
        loading: false,
      };
    case actions.SEARCH_ORGANIZATION_ERR:
      return {
        ...state,
        error: err,
        loading: false,
      };
    default:
      return state;
  }
};

const organizationReducer = (state = initialStateSingle, action) => {
  const { type, data, err } = action;
  switch (type) {
    case actions.ORGANIZATION_READ_BEGIN:
      return {
        ...initialStateSingle,
        loading: true,
      };

    case actions.ORGANIZATION_READ_SUCCESS:
      return {
        ...initialStateSingle,
        data,
        error: false,
        loading: false,
      };

    case actions.ORGANIZATION_READ_ERR:
      return {
        ...initialStateSingle,
        error: err,
        loading: false,
      };

    default:
      return state;
  }
};

export { organizationsReducer, organizationReducer, organizationSearchReducer };
